import moment from "moment/moment"
import { balanceTypes } from "../balanceCustRPT/balanceCustRPT-services";

   export const getSAdefaultValues = (t) => ({
        firstTime: true,
        type: balanceTypes[1],
       //dateFrom: moment(new Date()).format('YYYY-MM-DD'),
      //  dateTo: moment(new Date()).format('YYYY-MM-DD'),
        dateFrom: moment(new Date()).format('YYYY-MM-DD'),
        timeFrom: moment(new Date()).startOf("day").format("HH:mm"),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        timeTo: moment(new Date()).endOf("day").format("HH:mm"),
        branch:{id:-1, name:t('all')},
        account: {id: -1, name:''},
        omla:{id:-1, name:t('all')},
        user:{id:-1, name:t('all')},

        // openBalance:true,
        // oldBalance: true,
        
    });
    